import { render } from "./operation.vue?vue&type=template&id=60270f92"
import script from "./operation.vue?vue&type=script&lang=ts"
export * from "./operation.vue?vue&type=script&lang=ts"
script.render = render

export default script